import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

class AxisSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      label: 'name',
      title: 'Eixo',
      items: [
        {id: 'X', name: 'X'},
        {id: 'Y', name: 'Y'}]
    };
  }
}

AxisSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default AxisSelector;



// WEBPACK FOOTER //
// ./src/map/epc-distance/AxisSelector.js